import axios from 'axios'

export const axiosBasic = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Authorization': `Basic ${process.env.REACT_APP_API_TOKEN}`
    }
})


export const axiosBearer = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

const getToken = () => localStorage.getItem('APP_ACCESS_TOKEN');

axiosBearer.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${JSON.parse(token)}`;
        }
        config.headers['Content-Type'] = `application/json`;
        return config;
    },
    error => Promise.reject(error)
);

axiosBearer.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {

            localStorage.clear();

            window.location = '/login?expirado=true';
        }
        return Promise.reject(error);
    }
);